var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_10492_60190)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_10492_60190",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10492_60190",
    transform: "scale(0.0103093 0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10492_60190",
    width: 97,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAABgCAMAAAA6hOw0AAAAh1BMVEUAAAAIgEEIgEDqdiYJgEHpdiYIgEHndSUIgEDncyXpdiYIgEDfcCAJgEEJgEHpdiXqdybmciUQgEDodSXodSXodCfpdCPndCQGgEDpdiYIgEEJgEHvcCAJgEIefjyBezKeeS8Hf0DpdiYJgEEXfz95ezPbdyglfj2VejC8dyvNdyk3fjtdfDbRLni1AAAAInRSTlMAv0Dv39+AYCAggGAQ78/PnzAQv5BwUEAwr6CQEK9Y7+9wCxQuZAAAAdBJREFUaN7tmcluwkAQRNt2zOAQwGxmzVadDZL//74gcuiWDORSfUjkd5vT0xMMhWXp6Ojo+LskMVa58JkUd3Z4zoTPArd2yDQgYgYXocqP2AEWkavyIxrAIrYaEFHDRYw0IKKERfRV+REVYBEDVX5EAiziXgMi1nARQw2IKGARuSo/YglYRE+VHzEHLCLTgIgxLGKqyo+oYBQPqvyIBMejBkTUcLy9BESU8LzyIyZAcMQCCI6YIThiBwRHNEBwRI3oiBLBERUQHJGA4Ig1oiMKnI14p0UscZ4PdQwI89bGR9wQ5i0uogKCIxIQHFEjOqLERfb+1vVI88YXyOLKp0ARyCxasMMFXlk3uokWSP27YJhz560tWPHnDV/+oq2489YW9Pnz9vbJFEgRLWjP28ELRiagzdvh3Qum1Ke3tiAjCKprgg3t6c3Ye8FWGKzJc9CmjBYs4XhSqqA9b/MsQODn7VZYc+DZeUEeIJDGCWR7aQ4o87YQkRFfYN/VJCJ92o9p+69YkeTIIEAg6UcwOR3uAwQycwIZBggER8pKTuS2NzyWTiA92xsecyeQTHXDFsjYCaa2NzwqjO2FyYNuhU5yAtn0hE/jBDKQjo6Ojv/EN+X04vB1LvP4AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpi);
export default __webpack_public_path__ + "static/media/upi.aa3ca933c736187c382b1a21c817fdcc.svg";
export { ForwardRef as ReactComponent };